import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes, fonts } from "@similarweb/styles";
import styled from "styled-components";

export const StyledText = styled.span`
    color: ${colorsPalettes.carbon["300"]};
    font-family: ${fonts.$dmSansFontFamily};
    font-size: 14px;
    font-weight: 500;
    line-height: 16px;
`;

export const StyledIcon = styled(SWReactIcons)`
    margin-right: 8px;

    svg {
        width: 16px;
    }
`;

export const StyledNumberOfSignals = styled(StyledText)`
    margin-left: 4px;

    &:before {
        content: "(";
    }

    &:after {
        content: ")";
    }
`;

export const StyledInnerWrap = styled.div`
    display: flex;
    align-items: center;
`;

export const StyledSignalTypeWrap = styled.div`
    background-color: transparent;
    border-radius: 4px;
    box-sizing: border-box;
    cursor: pointer;
    min-height: 42px;
    padding: 13px 16px;
    user-select: none;

    & ${StyledIcon} {
        & svg {
            visibility: visible !important;

            path {
                fill: ${colorsPalettes.carbon["300"]};
            }
        }
    }

    &:hover {
        background-color: ${colorsPalettes.sky["100"]};
    }

    &.--active,
    &.--active:hover {
        background-color: ${colorsPalettes.blue["100"]};
        cursor: default;

        & ${StyledIcon} {
            & svg path {
                fill: ${colorsPalettes.carbon["500"]};
            }
        }

        & ${StyledText} {
            color: ${colorsPalettes.carbon["500"]};
            font-weight: 700;
        }
    }
`;
